export default __webpack_public_path__ + "static/media/amulet.bf464bec.png";